<template>
  <div class="row mb-0">
    <div class="col">
      <h1>{{ title }}</h1>
      <p>
        <em>
          {{ details }}
          {{
            includeDisclaimer
              ? "Answer only those questions you feel comfortable answering. There are no right or wrong answers."
              : ""
          }}
        </em>
      </p>
      <div class="alert alert-danger" role="alert" v-if="errorMessage">
        <strong>{{ errorMessage }}</strong>
        {{ errorDetails }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sectionHeader",
  props: {
    title: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    details: {
      type: String,
      required: false,
      default: () => {
        return "";
      }
    },
    includeDisclaimer: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      }
    },
    errorMessage: {
      type: String,
      required: false,
      default: () => {
        return "";
      }
    },
    errorDetails: {
      type: String,
      required: false,
      default: () => {
        return "";
      }
    }
  }
};
</script>
